import { render, staticRenderFns } from "./VehicleIconTemplate.vue?vue&type=template&id=c628163c&scoped=true&"
import script from "./VehicleIconTemplate.vue?vue&type=script&lang=js&"
export * from "./VehicleIconTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c628163c",
  null
  
)

export default component.exports